import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Button, Col, Row } from 'react-bootstrap';
import MSelect from '../components/MSelect';
import {
  fetchMasterTargetTypeDrops,
  targetSelector,
} from '../features/setTargetSlice';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import { MapOptionType, SelectOptionType } from '../utils/Types';
import {
  fetchGridsOfVillage,
  fetchVillagesOfDistricts,
  locationFilterSelector,
} from '../features/locationFilterSlice';
import {
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  TARGET_FILTER_INIT,
} from '../utils/Constant';
import {
  handleApplyButton,
  onDistrictChange,
  onStateChange,
  onVillageChange,
  onZoneChange,
} from '../pages/targets/SetTargetHelper';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';

interface ISetTargetFilterNewProps {
  selectedFiltersData?: any;
  setSelectedFiltersData?: any;
  onApply?: any;
  tableFilters?: any;
  onReset: () => void;
}

const SetTargetFilterNew: React.FunctionComponent<ISetTargetFilterNewProps> = ({
  selectedFiltersData,
  setSelectedFiltersData,
  onApply,
  tableFilters,
  onReset,
}) => {
  const dispatch = useAppDispatch();

  const [stateOption, setStateOption] = useState<SelectOptionType[]>([
    DEFAULT_OPTION_LOCATION_SET_TARGET,
  ]);
  const [districtOption, setDistrictOption] = useState<SelectOptionType[]>([
    DEFAULT_OPTION_LOCATION_SET_TARGET,
  ]);
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;
  const cityOptions: MapOptionType = useAppSelector(
    locationFilterSelector
  ).cityOptions;
  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;
  const gridArray: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).gridOptions;
  const yearOptions: SelectOptionType[] =
    useAppSelector(targetSelector).yearOptions;
  const salesTargetOptions: SelectOptionType[] =
    useAppSelector(targetSelector).salesTargetOptions;
  const seasonOptions: SelectOptionType[] =
    useAppSelector(targetSelector).seasonOptions;
  const productsOptions: SelectOptionType[] =
    useAppSelector(targetSelector).productsOptions;

  const zoneOptions =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;

  const setStateArrayData = (array: SelectOptionType[]) => {
    if (array && array.length === 1) {
      setStateOption(array);
    } else {
      setStateOption([DEFAULT_OPTION_LOCATION_SET_TARGET, ...(array || [])]);
    }
  };

  /** Resets the filter to its initial state. */
  const resetFilter = () => {
    const newFilter = { ...TARGET_FILTER_INIT };
    if (stateOption && stateOption.length === 1) {
      newFilter.state = stateOption[0].value;
    } else {
      setDistrictOption([DEFAULT_OPTION_LOCATION_SET_TARGET]);
    }
    if (zoneOptions && zoneOptions.length === 1) {
      newFilter.zone = zoneOptions[0].value;
    } else {
      setStateArrayData([DEFAULT_OPTION_LOCATION_SET_TARGET]);
    }
    setSelectedFiltersData(newFilter);
    onReset();
  };

  useEffect(() => {
    if (zoneOptions && zoneOptions.length === 1) {
      onZoneChange(
        { target: { value: zoneOptions[0].value } },
        selectedFiltersData,
        allStates,
        setSelectedFiltersData,
        setStateArrayData
      );
    }
  }, [zoneOptions]);
  useEffect(() => {
    if (stateOption && stateOption.length === 1) {
      onStateChange(
        { target: { value: stateOption[0].value } },
        selectedFiltersData,
        districtData,
        setSelectedFiltersData,
        setDistrictOption
      );
    }
  }, [stateOption]);

  /**
   * Sets filter values and fetches dropdown options based on user clicks on table target.
   */
  useEffect(() => {
    if (
      tableFilters?.village !== 'All' &&
      tableFilters?.village &&
      selectedFiltersData?.village !== tableFilters?.village
    ) {
      dispatch(
        fetchGridsOfVillage({
          villageId: tableFilters?.village,
          pincode: null,
          candidateId: null,
        })
      );
    }
    if (
      tableFilters?.district !== 'All' &&
      tableFilters?.district &&
      selectedFiltersData?.district !== tableFilters?.district &&
      !cityOptions[tableFilters?.district]
    ) {
      dispatch(
        fetchVillagesOfDistricts({
          districtId: [Number(tableFilters?.district)],
        })
      );
    }
    if (
      tableFilters?.state !== 'All' &&
      tableFilters?.state &&
      selectedFiltersData?.state !== tableFilters?.state
    ) {
      setDistrictOption([
        DEFAULT_OPTION_LOCATION_SET_TARGET,
        ...(districtData[tableFilters?.state] || []),
      ]);
    }
    if (
      tableFilters?.zone !== 'All' &&
      tableFilters?.zone &&
      selectedFiltersData?.zone !== tableFilters?.zone
    ) {
      setStateArrayData(allStates[tableFilters?.zone]);
    }
    if (tableFilters?.zone !== 'All' && tableFilters?.zone) {
      setSelectedFiltersData(tableFilters);
    }
  }, [tableFilters]);

  /**
   *  Fetches dropdown options for year, season, target type, and product type.
   */
  useEffect(() => {
    dispatch(fetchMasterTargetTypeDrops());
  }, []);

  const gridDropOptions =
    selectedFiltersData.village && selectedFiltersData.village !== 'All'
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...(gridArray || [])]
      : [DEFAULT_OPTION_LOCATION_SET_TARGET];

  const cleanedGridOptions = gridDropOptions.filter(
    (opt) => opt.value !== 'All'
  );
  const allGridValues = cleanedGridOptions.map((opt) => String(opt.value));

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  const isAllCheckedGrid =
    selectedFiltersData?.grid?.length === allGridValues?.length;

  const allVillagesData = cityOptions?.[selectedFiltersData?.district] ?? [];
  const allVillageValuesData = allVillagesData?.map((opt: any) =>
    String(opt.value)
  );
  const isAllAlreadySelectedData =
    selectedFiltersData?.village?.length === allVillageValuesData?.length;
  return (
    <div className="container-parent">
      <div className=" inner-div pt-4">
        <Row>
          <Col xs={6} md={3} className="mb-2">
            <MSelect
              label="Year"
              required
              options={yearOptions}
              value={selectedFiltersData.year}
              onChange={(e) => {
                setSelectedFiltersData({
                  ...selectedFiltersData,
                  year: e.target.value,
                });
              }}
            />
          </Col>
          <Col xs={6} md={3} className="mb-2">
            <MSelect
              label="Season"
              required
              options={seasonOptions ?? []}
              value={selectedFiltersData.season}
              onChange={(e) => {
                setSelectedFiltersData({
                  ...selectedFiltersData,
                  season: e.target.value,
                });
              }}
            />
          </Col>
          <Col xs={6} md={3}>
            <MSelect
              label="Target Type"
              required
              options={salesTargetOptions}
              value={selectedFiltersData.target}
              onChange={(data) => {
                setSelectedFiltersData((prev: any) => ({
                  ...prev,
                  target: data.target.value,
                }));
              }}
            />
          </Col>
          <Col xs={6} md={3}>
            <MSelect
              label="Product Type"
              options={productsOptions}
              value={selectedFiltersData.product || '0'}
              onChange={(data) => {
                setSelectedFiltersData((prev: any) => ({
                  ...prev,
                  product: data.target.value,
                }));
              }}
            />
          </Col>
        </Row>
        <Label className="mt-4 active-emp">Set Targets:</Label>
        <Row>
          <Col xs={6} md className="mb-2">
            <MSelect
              label="Zone"
              options={zoneOptions}
              value={selectedFiltersData.zone}
              onChange={(event) => {
                onZoneChange(
                  event,
                  selectedFiltersData,
                  allStates,
                  setSelectedFiltersData,
                  setStateArrayData
                );
              }}
            />
          </Col>

          <Col xs={6} md className="mb-2">
            <MSelect
              label="State"
              options={stateOption}
              value={selectedFiltersData.state}
              onChange={(e) => {
                onStateChange(
                  e,
                  selectedFiltersData,
                  districtData,
                  setSelectedFiltersData,
                  setDistrictOption
                );
              }}
            />
          </Col>
          <Col xs={6} md className="mb-2">
            <MSelect
              label="District"
              options={districtOption}
              value={selectedFiltersData.district}
              onChange={(e) => {
                onDistrictChange(
                  e,
                  selectedFiltersData,
                  cityOptions,
                  setSelectedFiltersData,
                  dispatch
                );
              }}
            />
          </Col>

          <Col xs={6} md className="mb-2">
            <div style={{ marginTop: '-6px' }}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                disableClearable
                clearIcon={null}
                noOptionsText="No village found"
                options={[
                  { label: 'All', value: 'All' },
                  ...(cityOptions?.[selectedFiltersData?.district] ?? []),
                ]}
                getOptionLabel={(option: any) => option.label || ''}
                filterOptions={(options, { inputValue }) => {
                  const normalizedInput = inputValue.toLowerCase();
                  return options.filter(
                    (opt: any) =>
                      opt.label.toLowerCase().includes(normalizedInput) ||
                      opt.value.toLowerCase().includes(normalizedInput)
                  );
                }}
                value={(
                  cityOptions?.[selectedFiltersData?.district] ?? []
                ).filter((opt: any) =>
                  selectedFiltersData?.village?.includes(opt.value)
                )}
                onChange={(event: any, selectedOptions: any) => {
                  const selectedValues = selectedOptions.map((opt: any) =>
                    String(opt.value)
                  );
                  const allVillages =
                    cityOptions?.[selectedFiltersData?.district] ?? [];
                  const allVillageValues = allVillages.map((opt: any) =>
                    String(opt.value)
                  );

                  let finalValues: string[] = [];

                  if (selectedValues.includes('All')) {
                    const isAllAlreadySelected =
                      selectedFiltersData.village.length ===
                      allVillageValues.length;
                    finalValues = isAllAlreadySelected ? [] : allVillageValues;
                  } else {
                    finalValues = selectedValues.filter(
                      (v: string) => v !== 'All'
                    );
                  }

                  onVillageChange(
                    finalValues,
                    selectedFiltersData,
                    setSelectedFiltersData,
                    dispatch
                  );
                }}
                renderOption={(props: any, option: any, { selected }) => (
                  <li {...props} key={`${option.value}-${option.label}`}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected || isAllAlreadySelectedData}
                    />
                    {option.label}
                  </li>
                )}
                renderTags={() => null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    label="Villages"
                    placeholder="Search villages"
                    InputLabelProps={{
                      sx: {
                        fontSize: '12px',
                        pb: '4px',
                        '&.MuiInputLabel-shrink': {
                          fontSize: '14px',
                          color: 'black',
                        },
                        '& .MuiFormLabel-asterisk': {
                          color: 'red',
                        },
                      },
                    }}
                  />
                )}
              />
            </div>
          </Col>

          <Col xs={6} md className="mb-2">
            <div style={{ marginTop: '-6px' }}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                disableClearable
                clearIcon={null}
                noOptionsText="No Grid found"
                options={[
                  { label: 'All', value: 'All' },
                  ...cleanedGridOptions,
                ]}
                getOptionLabel={(option: any) => option.label}
                value={cleanedGridOptions.filter((opt) =>
                  selectedFiltersData?.grid?.includes(opt.value)
                )}
                onChange={(event: any, selectedOptions: any) => {
                  const selectedValues = selectedOptions.map(
                    (opt: { value: any }) => String(opt.value)
                  );
                  const isAllClicked = selectedValues.includes('All');
                  const isAllAlreadySelected =
                    selectedFiltersData.grid.length === allGridValues.length;

                  const finalValues = isAllClicked
                    ? isAllAlreadySelected
                      ? []
                      : allGridValues
                    : selectedValues.filter((v: string) => v !== 'All');

                  setSelectedFiltersData({
                    ...selectedFiltersData,
                    grid: finalValues,
                  });
                }}
                renderOption={(props: any, option: any, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected || isAllCheckedGrid}
                    />
                    {option.label}
                  </li>
                )}
                renderTags={() => null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    label="Grids"
                    placeholder="Search Grids"
                    InputLabelProps={{
                      sx: {
                        fontSize: '12px',
                        pb: '4px',
                        '&.MuiInputLabel-shrink': {
                          fontSize: '14px',
                          color: 'black',
                        },
                        '& .MuiFormLabel-asterisk': {
                          color: 'red',
                        },
                      },
                    }}
                  />
                )}
              />
            </div>
          </Col>
        </Row>

        <Col xs={6} md={4}>
          <div className="d-flex justify-content-left mt-4 pt-1">
            <Button
              variant="primary"
              className="cl-btn-primary"
              onClick={() => {
                handleApplyButton(
                  selectedFiltersData,
                  zoneOptions,
                  stateOption,
                  districtOption,
                  cityOptions,
                  onApply
                );
              }}
            >
              Apply
            </Button>
            <Button
              variant="outline-primary"
              className="mx-2 cl-btn-outline-primary"
              onClick={() => {
                resetFilter();
              }}
            >
              Reset
            </Button>
          </div>
        </Col>
      </div>
    </div>
  );
};

export default SetTargetFilterNew;
